import React, { useEffect, useState } from 'react';
import { ProButton } from '../../../../atoms/Button/ProButton';
import { ProIconButton } from '../../../../atoms/Button/ProIconButton';
import { ProIconTypeData } from '../../../../atoms/Icons/IconData';
import { ProFilterPopup } from '../../../../atoms/ProFilterPopup/ProFilterPopup';
import { ProIntent } from '../../../../utils/enums';
import { Components } from '../../../../utils/types';

export const useReqFilter = (refinedData: Components.Schemas.RequirementDTO[]) => {
    const [filter, setFilter] = useState(['done']);
    const [search, setSearch] = useState<string>();
    const [filteredData, setFilteredData] = useState<Components.Schemas.RequirementDTO[]>([]);
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        const res = refinedData.filter((cur) => !filter?.includes(cur.requirementState?.name ?? 'undefined'));
        setFilteredData(filter ? res : refinedData);
    }, [refinedData, filter]);

    const addOrRemoveFromFilter = (item: string) => {
        if (filter?.includes(item)) setFilter(filter.filter((cur) => cur !== item));
        else setFilter((cur) => (cur ? [...cur, item] : [item]));
    };

    const render = () => (
        <ProFilterPopup isOpen={isOpen} setIsOpen={setIsOpen} isActive={filter.length >= 1}>
            <h4>By status</h4>
            <div>
                <ProIconButton
                    className="ProButtonRow--first"
                    icon={ProIconTypeData.Funnel}
                    onClick={() => addOrRemoveFromFilter('in funnel')}
                    mainIntent={filter?.includes('in funnel') ? ProIntent.Gray : ProIntent.Primary}
                    tooltip="in funnel"
                    placement="bottom"
                />
                <ProIconButton
                    icon={ProIconTypeData.NotReady}
                    onClick={() => addOrRemoveFromFilter('not ready')}
                    mainIntent={filter?.includes('not ready') ? ProIntent.Gray : ProIntent.Primary}
                    tooltip="not ready"
                    placement="bottom"
                />
                <ProIconButton
                    icon={ProIconTypeData.Ready}
                    onClick={() => addOrRemoveFromFilter('ready')}
                    mainIntent={filter?.includes('ready') ? ProIntent.Gray : ProIntent.Primary}
                    tooltip="ready"
                    placement="bottom"
                />
                <ProIconButton
                    icon={ProIconTypeData.Scheduled}
                    onClick={() => addOrRemoveFromFilter('scheduled')}
                    mainIntent={filter?.includes('scheduled') ? ProIntent.Gray : ProIntent.Primary}
                    tooltip="scheduled"
                    placement="bottom"
                />
                <ProIconButton
                    icon={ProIconTypeData.UnderDev}
                    onClick={() => addOrRemoveFromFilter('under development')}
                    mainIntent={filter?.includes('under development') ? ProIntent.Gray : ProIntent.Primary}
                    tooltip="under development"
                    placement="bottom"
                />
                <ProIconButton
                    icon={ProIconTypeData.Review}
                    onClick={() => addOrRemoveFromFilter('ready for review')}
                    mainIntent={filter?.includes('ready for review') ? ProIntent.Gray : ProIntent.Primary}
                    tooltip="ready for review"
                    placement="bottom"
                />
                <ProIconButton
                    icon={ProIconTypeData.OnHold}
                    onClick={() => addOrRemoveFromFilter('on hold')}
                    mainIntent={filter?.includes('on hold') ? ProIntent.Gray : ProIntent.Primary}
                    tooltip="on hold"
                    placement="bottom"
                />
                <ProIconButton
                    icon={ProIconTypeData.Rejected}
                    onClick={() => addOrRemoveFromFilter('rejected')}
                    mainIntent={filter?.includes('rejected') ? ProIntent.Gray : ProIntent.Primary}
                    tooltip="rejected"
                    placement="bottom"
                />
                <ProIconButton
                    icon={ProIconTypeData.Finnished}
                    tooltip={'done'}
                    onClick={() => addOrRemoveFromFilter('done')}
                    mainIntent={filter?.includes('done') ? ProIntent.Gray : ProIntent.Primary}
                    className="ProButtonRow--last"
                    placement="bottom"
                />
            </div>
            <h4>By priority</h4>
            <div>
                <ProButton
                    text="low"
                    onClick={() => addOrRemoveFromFilter('low')}
                    mainIntent={filter?.includes('low') ? ProIntent.Gray : ProIntent.Primary}
                    className="ProButtonRow--first"
                    placement="bottom"
                />
                <ProButton
                    text="medium"
                    onClick={() => addOrRemoveFromFilter('medium')}
                    mainIntent={filter?.includes('medium') ? ProIntent.Gray : ProIntent.Primary}
                    placement="bottom"
                />
                <ProButton
                    text="high"
                    onClick={() => addOrRemoveFromFilter('high')}
                    mainIntent={filter?.includes('high') ? ProIntent.Gray : ProIntent.Primary}
                    placement="bottom"
                />
            </div>
        </ProFilterPopup>
    );
    return { filter, search, render, filteredData };
};
